module.exports = __webpack_public_path__ + "img/quality.db663922.svg";